import { render, staticRenderFns } from "./IndexLayout.vue?vue&type=template&id=625516f0"
import script from "./IndexLayout.vue?vue&type=script&lang=ts"
export * from "./IndexLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports